<div class="main">
  <div *ngIf="showLoader" class="loader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="body">
      <div class="invoiceSection">
        <div class="invoiceHeader">
          <div class="label">
            {{'accountSettings.invoiceSettings' | translate}}
          </div>
        </div>
        <div class="invoiceBody">
          <div class="top">
            <div class="topLeft">

              <div class="topLeftDefault" *ngIf="!invoiceSequence.custom_IINC_enabled">
                <div class="topLeftHeader">
                  <div class="label">
                    {{'accountSettings.defaultFormat' | translate}}
                  </div>
                </div>
                <div class="topLeftBody">
                  <div class="bodySection">
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.invoiceNumber' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [disabled]="true" [(ngModel)]="invoiceSequenceDefault.series">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="topLeftCustom" [ngStyle]="{'flex': !invoiceSequence.custom_IINC_enabled ? '0.5':'1'}">
                <div class="topRightHeader">
                  <div class="label">
                    {{'accountSettings.customFormat' | translate}}
                  </div>
                </div>
                <div class="topRightBody">
                  <div class="bodySection">
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.from' | translate}}
                      </div>
                      <div class="input">
                        <input type="number" [(ngModel)]="invoiceSequence.custom_range.from">
                      </div>
                    </div>
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.to' | translate}}
                      </div>
                      <div class="input">
                        <input type="number" [(ngModel)]="invoiceSequence.custom_range.to">
                      </div>
                    </div>
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.customText' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [(ngModel)]="invoiceSequence.custom_text">
                      </div>
                    </div>
                    <div class="submitButton">
                      <div class="button" (click)="updateInvoiceSeq();">
                        {{'accountSettings.submit' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="topRight">
              <div class="middleHeader">
                <div class="label">
                  {{'accountSettings.additionalCharges' | translate}}
                </div>
              </div>
              <div class="carrierSelect">
                <div class="carrierContainer">
                  <div class="label">
                    {{'accountSettings.shipper' | translate}}
                  </div>
                  <div class="input">
                    <mat-select class="inputSelect">
                      <mat-option *ngFor="let shipper of shippers" [value]="shipper.name"
                        (onSelectionChange)="getCharges($event, shipper)">
                        {{shipper.parent_name}} - {{shipper.name}}
                      </mat-option>
                    </mat-select>
                  </div>
                </div>
              </div>
              <div class="charges">
                <div class="middleLeft">
                  <div class="middleLeftBody">
                    <div class="bodySection">
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.porter' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.labour"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.insurance' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.insurance"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.toll' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.toll"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.extra_pickup' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.extra_pickup"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.extra_delivery' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.extra_delivery"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.GTA' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="GTAToGTA"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.odcCharges' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.odc_charges"></mat-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="middleRight">
                  <div class="middleRightBody">
                    <div class="bodySection">
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.documentCharges' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.doc"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.cancellation' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.cancellation"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.nonHometownHalt' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.non_hometown_halt"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.lr' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.LR_charges"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.detentionCustomer' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.detentionCustomer"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.detentionPlant' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.detentionPlant"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.green_tax' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.green_tax"></mat-slide-toggle>
                        </div>
                      </div>
                      <div class="toggleContainer">
                        <div class="label">
                          {{'accountSettings.rtoFines' | translate}}
                        </div>
                        <div class="toggle">
                          <mat-slide-toggle [(ngModel)]="additionalCharges.rto_fines"></mat-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submitButton">
                <div class="button" (click)="updateCharges();">
                  {{'accountSettings.submit' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="bottomHeader">
              <div class="label">
                {{'accountSettings.otherDetails' | translate}}
              </div>
            </div>
            <div class="bottomContent">


              <div class="bottomRight">
                <div class="bottomRightBody">
                  <div class="bodySection">
                    <div class="container">
                      <div class="label">
                        {{'accountSettings.creditNoteNarration' | translate}}
                      </div>
                      <div class="termsContainer">
                        <textarea name="" id="" cols="67" rows="12" [(ngModel)]="creditNoteNarration"></textarea>
                      </div>
                    </div>
                    <div class="submitButton">
                      <div class="button" (click)="updatecreditNoteNarration();">
                        {{'accountSettings.submit' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bottomLeft">
                <div class="bottomLeftBody">
                  <div class="bodySection">
                    <div class="container">
                      <div class="label">
                        {{'accountSettings.terms' | translate}}
                      </div>
                      <div class="termsContainer">
                        <textarea name="" id="" cols="67" rows="11" [(ngModel)]="invoice_defaultTc"></textarea>
                      </div>
                    </div>
                    <div class="submitButton">
                      <div class="button" (click)="updateInvoiceTermsAndConditions()">
                        {{'accountSettings.submit' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="billingSection">
        <div class="billingHeader">
          <div class="label">
            {{'accountSettings.billSettings' | translate}}
          </div>
        </div>
        <div class="billingBody">
          <div class="top">
            <div class="topLeft">

              <div class="topLeftDefault" *ngIf="!billSequence.custom_CBIN_enabled">
                <div class="topLeftHeader">
                  <div class="label">
                    {{'accountSettings.defaultFormat' | translate}}
                  </div>
                </div>
                <div class="topLeftBody">
                  <div class="bodySection">
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.billNumber' | translate}}
                      </div>
                      <div class="input">
                        <input [disabled]="true" type="text" [(ngModel)]="billSequenceDefault.series">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="topRightCustom" [ngStyle]="{'flex': !billSequence.custom_CBIN_enabled ? '0.5':'1'}">
                <!-- [ngClass]="{'topRight':!billSequence.custom_CBIN_enabled ,'topRight_custom':billSequence.custom_CBIN_enabled}" -->
                <div class="topRightHeader">
                  <div class="label">
                    {{'accountSettings.customFormat' | translate}}
                  </div>
                </div>
                <div class="topRightBody">
                  <div class="bodySection">
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.from' | translate}}
                      </div>
                      <div class="input">
                        <input type="number" [(ngModel)]="billSequence.custom_range.from">
                      </div>
                    </div>
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.to' | translate}}
                      </div>
                      <div class="input">
                        <input type="number" [(ngModel)]="billSequence.custom_range.to">
                      </div>
                    </div>
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.customText' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [(ngModel)]="billSequence.custom_text">
                      </div>
                    </div>
                    <div class="submitButton">
                      <div class="button" (click)="updateBillSeq();">
                        {{'accountSettings.submit' | translate}}
                      </div>
                    </div>
                    <div class="inputContainer" style="margin-top:20px">
                      <div class="label">
                        {{'accountSettings.sac_code' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [(ngModel)]="sac_code">
                      </div>
                    </div>
                    <div class="submitButton">
                      <div class="button" (click)="updateSACCOde();">
                        {{'accountSettings.submit' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="topRight">
              <div class="middleLeft">
                <div class="middleLeftHeader">
                  <div class="label">
                    {{'accountSettings.gstDetails' | translate}}
                  </div>
                </div>
                <div class="middleLeftBody">
                  <div class="bodySection">
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.gstin' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [disabled]="tempGSTIN.disabled" [(ngModel)]="paymentInfo.tax_details.GSTIN">
                      </div>
                    </div>
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.pan' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [(ngModel)]="paymentInfo.tax_details.PAN">
                      </div>
                    </div>
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.transporter_id' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [disabled]="tempGSTIN.disabled"
                          [(ngModel)]="paymentInfo.tax_details.tax_id_3">
                      </div>
                    </div>
                    <div class="inputContainer">

                      <div class="input">
                        <mat-checkbox (change)="urdChanges($event.checked)" [(ngModel)]="paymentInfo.URD">
                          {{'accountSettings.unregisteredDealer' | translate}}</mat-checkbox>
                      </div>
                    </div>
                    <!-- <div class="submitButton">
                                            <div class="button">
                                                Submit
                                            </div>
                                        </div> -->
                  </div>
                </div>
              </div>
              <div class="middleRight">
                <div class="middleRightHeader">
                  <div class="label">
                    {{'accountSettings.bankDetails' | translate}}
                  </div>
                </div>
                <div class="middleRightBody">
                  <div class="bodySection">
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.bankName' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [(ngModel)]="paymentInfo.bank_details.name">
                      </div>
                    </div>
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.accNo' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [(ngModel)]="paymentInfo.bank_details.account_number">
                      </div>
                    </div>
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.branch' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [(ngModel)]="paymentInfo.bank_details.branch_name">
                      </div>
                    </div>
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.ifsc' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [(ngModel)]="paymentInfo.bank_details.branch_code">
                      </div>
                    </div>
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.iba_code' | translate}}
                      </div>
                      <div class="input">
                        <input type="text" [(ngModel)]="paymentInfo.bank_details.iba_code">
                      </div>
                    </div>
                    <div class="submitButton">
                      <div class="button" (click)="updatePaymentInfo();">
                        {{'accountSettings.submit' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="signature_upload" style="margin-bottom: 10px;">



            <div class="bottomLeft">
              <div class="bottomHeader">
                <div class="label">
                  {{'accountSettings.signature_details' | translate}}
                </div>
              </div>
              <div class="content-logo">
                <div class="inputSection">
                  <div class="label">
                    {{'accountSettings.Please_select_signature' | translate}}
                  </div>
                  <input class="form-input" style="margin:0px" id="containerNo" accept="image/*, .pdf"
                    (change)="fileChanged($event)" type="file" />
                </div>
                <div class="preview" *ngIf="logo">
                  <img src="{{logo}}" height="190" width="150">
                </div>
              </div>
            </div>
            <div class="bottomRight">
              <div class="bottomHeader">
                <div class="label">
                  {{'accountSettings.e_invoice_details' | translate}}
                </div>
              </div>
              <div class="toggleContainer">
                <div class="label">
                  {{'accountSettings.e_invoice_declaration' | translate}}
                </div>
                <div class="toggle">
                  <mat-slide-toggle [(ngModel)]="invoiceDeclaration" (change)="onToggle($event)"></mat-slide-toggle>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="bottomHeader">
              <div class="label">
                {{'accountSettings.otherDetails' | translate}}
              </div>
            </div>
            <div class="bottomContent">

              <div class="bottomLeft">
                <div class="bottomLeftBody">
                  <div class="bodySection">
                    <div class="inputContainer">
                      <div class="label">
                        {{'accountSettings.billingEmail' | translate}}
                      </div>
                      <div class="inpSub">

                        <div class="input">
                          <input type="text" [(ngModel)]="billing_emails">
                          <mat-hint style="display: block; font-size:12px; padding:3px">
                            {{'accountSettings.billingEmail_multiple' | translate}}</mat-hint>
                        </div>
                        <div class="submitButton">
                          <div class="button" (click)="updateBillingEmails()">
                            {{'accountSettings.submit' | translate}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="inputContainer" style="margin-top:20px">
                      <div class="label">
                        {{'accountSettings.tax_type' | translate}}
                      </div>
                      <div class="inpSub">

                        <div class="input">
                          <mat-select class="inputSelect" [(ngModel)]="selectedTaxType" [disabled]="disable_tax_type">
                            <mat-option *ngFor="let tax_type of tax_types" [value]="tax_type"
                              (click)="selectTaxType(tax_type)">
                              {{tax_type.name}}
                            </mat-option>
                          </mat-select>
                        </div>
                        <div class="submitButton">
                          <div class="button" (click)="updateTaxType()">
                            {{'accountSettings.submit' | translate}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bottomRight">
                <div class="bottomRightBody">
                  <div class="bodySection">
                    <div class="container">
                      <div class="label">
                        {{'accountSettings.terms' | translate}}
                      </div>
                      <div class="termsContainer">
                        <textarea name="" id="" cols="67" rows="11" [(ngModel)]="bill_defaultTc"></textarea>
                      </div>
                    </div>
                    <div class="submitButton">
                      <div class="button" (click)="updateBillTermsAndConditions()">
                        {{'accountSettings.submit' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="bodySection">
                    <div class="billing-container">
                      <div class="label">
                        {{'accountSettings.billing_address' | translate}}
                      </div>
                      <div class="termsContainer">
                        <textarea name="" id="" cols="67" rows="8" [(ngModel)]="billing_address"></textarea>
                      </div>
                    </div>
                    <div class="submitButton">
                      <div class="button" (click)="updateBillingAddress()">
                        {{'accountSettings.submit' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>